import { useState } from 'react';
import { useTranslation } from 'react-i18next';

const FAQ_KEYS = ['1','2','3','4','5','6','7','8'];

export default function FAQ() {
  const { t } = useTranslation();
  const [open, setOpen] = useState<number | null>(null);
  return (
    <section className="py-12 sm:py-16 md:py-20 bg-gradient-to-b from-card/30 to-background relative overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 relative z-10">
        <div className="text-center mb-10 sm:mb-14">
          <div className="inline-flex items-center gap-2 bg-primary/10 border border-primary/20 rounded-full px-4 py-2 mb-4 sm:mb-6">
            <span className="text-sm font-medium text-primary">{t('faq.badge')}</span>
          </div>
          <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold mb-3 sm:mb-4">
            <span className="text-foreground">{t('faq.title1')} </span><span className="text-gradient">{t('faq.title2')}</span>
          </h2>
          <p className="text-muted-foreground text-base sm:text-lg max-w-2xl mx-auto">{t('faq.desc')}</p>
        </div>
        <div className="max-w-3xl mx-auto space-y-4">
          {FAQ_KEYS.map((n, i) => (
            <div key={n} className={`bg-card/60 backdrop-blur-sm border rounded-xl px-6 transition-colors ${open === i ? 'border-primary/50' : 'border-border/50'}`}>
              <button type="button" className="flex flex-1 items-center justify-between w-full text-left text-foreground hover:text-primary py-5 text-base sm:text-lg font-medium cursor-pointer" onClick={() => setOpen(open === i ? null : i)}>
                {t(`faq.q${n}`)}
                <i className={`ri-arrow-down-s-line text-xl flex-shrink-0 transition-transform duration-200 ${open === i ? 'rotate-180' : ''}`} />
              </button>
              {open === i && <div className="pb-5 text-sm text-muted-foreground leading-relaxed">{t(`faq.a${n}`)}</div>}
            </div>
          ))}
        </div>
        <div className="mt-10 sm:mt-14 text-center">
          <p className="text-muted-foreground mb-4">{t('faq.more')}</p>
          <a href="https://wa.me/12057092376" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 bg-gradient-primary text-white px-6 py-3 rounded-full font-semibold hover:opacity-90 transition-opacity cursor-pointer">
            <i className="ri-whatsapp-line" /> {t('faq.cta')}
          </a>
        </div>
      </div>
    </section>
  );
}
